<template>
  <v-card class="rounded-lg">
    <v-card-text>
      <div id="swagger-ui" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      isBundleLoaded: false,
      isStandaloneLoaded: false
    }
  },
  head () {
    return {
      script: [
        {
          type: 'text/javascript',
          src: 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-bundle.min.js',
          async: true,
          callback: () => { this.isBundleLoaded = true }
        },
        {
          type: 'text/javascript',
          src: 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-standalone-preset.min.js',
          async: true,
          callback: () => { this.isStandaloneLoaded = true }
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui.min.css'
        }
      ]
    }
  },
  computed: {
    allScriptsLoaded () {
      return this.isStandaloneLoaded && this.isBundleLoaded
    }
  },
  watch: {
    allScriptsLoaded (val) {
      if (val) {
        this.createPage()
      }
    }
  },
  mounted () {
    this.getBundle()
    this.getStandalone()
    this.getStyle()
  },
  beforeDestroy () {
    let scriptsToRemove = [
      document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-bundle.min.js"]'),
      document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-standalone-preset.min.js"]'),
      document.querySelector('link[href="https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui.min.css"]')
    ]

    scriptsToRemove.forEach(script => {
      if (script) {
        let parent = script.parentNode
        parent.removeChild(script)
      }
    })
  },
  methods: {
    getBundle () {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-bundle.min.js')
      document.head.appendChild(script)

      script.onload = () => {
        this.isBundleLoaded = true
      }
    },
    getStandalone () {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui-standalone-preset.min.js')
      document.head.appendChild(script)

      script.onload = () => {
        this.isStandaloneLoaded = true
      }
    },
    getStyle () {
      let link = document.createElement('link')
      link.rel = 'stylesheet'
      link.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/4.11.1/swagger-ui.min.css')
      document.head.appendChild(link)
    },
    createPage () {
      /* eslint-disable */
      const baseURL = this.$axios.defaults.baseURL
      const ui = SwaggerUIBundle({
        url: `/api/static/swagger.json`,
        dom_id: '#swagger-ui',
        deepLinking: true,
        presets: [SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset],
        layout: 'StandaloneLayout'
      })
      window.ui = ui
      /* eslint-enabled */
    }
  }
}
</script>
